export const DEFAULT_CATEGORY_SELECTION = "all-articles";
export const POPULAR_CATEGORIES_TITLE =
  "Popular Categories";
